import { render, staticRenderFns } from "./CardExceptionContainer.vue?vue&type=template&id=5ec38e9a&scoped=true"
import script from "./CardExceptionContainer.vue?vue&type=script&lang=js"
export * from "./CardExceptionContainer.vue?vue&type=script&lang=js"
import style0 from "./CardExceptionContainer.vue?vue&type=style&index=0&id=5ec38e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec38e9a",
  null
  
)

export default component.exports